import React from "react";
import Button from "./Button";
import Confirm from "../dialog/message/Confirm";

/**
 * Button that confirms with the user prior to executing the action.
 *
 * When the user presses the button, they are presented with a message asking if they are sure they want to continue (yes/no).
 *
 * This is used for "dangerous" actions such as deleting a record.
 * 
 * Props:
 * - message: Message to show the user, which can be a simple string or a react-intl object.
 * - onConfirm: Function called when the user presses the "Yes" button.
 * See Button, for additional props.
 */
class ConfirmButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { confirmShown: false };
    this.toggleConfirm = this.toggleConfirm.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  /**
   * Shows/hides the confirmation dialog.
   */
  toggleConfirm(confirmShown) {
    this.setState({ confirmShown });
  }

  /**
   * Called when the user presses the "Yes" button in the confirmation dialog.
   */
  onConfirm() {
    this.toggleConfirm(false);
 
    this.props.onConfirm();
  }

  render() {
    const { message, ...restProps } = this.props;

    return (
      <React.Fragment>
        {/* Button that is shown to the user prior to the confirmation dialog * (action that the user must confirm) */}
        <Button
          {...restProps}
          onPress={() => this.toggleConfirm(true)}
        />

        {/* Confirmation dialog that asks the user if they want to perform the action (yes/no) */}
        <Confirm
          isVisible={this.state.confirmShown}
          message={message}
          onConfirm={this.onConfirm}
          onCancel={() => this.toggleConfirm(false)}
        />
      </React.Fragment>
    );
  }
}

ConfirmButton.defaultProps = {
  onConfirm: () => {}
};

export default ConfirmButton;
